import React from "react";
import { FormControl, Grid, TextField} from "@mui/material";
import { Contact } from "../../model/Contact";
import { Trans, useTranslation } from "react-i18next";
import "../CSS/colorMessages.css";

interface ContactFormProps {
  contact: Contact;
  onChange: (updatedContact: Contact) => void;
  onBlur: (fieldName: string) => void;
  errorContactNom: string;
  errorContactPrenom: string;
  errorContactCourriel: string;
  errorContactTelephone: string;
}

const ContactForm: React.FC<ContactFormProps> = ({
  contact,
  onChange,
  onBlur,
  errorContactNom,
  errorContactPrenom,
  errorContactCourriel,
  errorContactTelephone,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    onChange({
      ...contact,
      [name]: value,
    });
  };
  const { t } = useTranslation();

 
  return (
    <>
  
      <Grid container>
     
        <Grid item xs={6}>
          <FormControl className="width-98" >
            <TextField required
              label={
                <Trans>
                  {t("formulaireContact.lblChampNom")}
                </Trans>
              }
              name="nom"
              autoComplete="family-name"
              value={contact.nom}
              onChange={handleChange}
              variant="filled"
              fullWidth
              aria-describedby="error-contact-nom"
              style={{ backgroundColor: errorContactNom ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
            />
            {errorContactNom && (
              <strong id="error-contact-nom" role="alert" className="error">
                <Trans>{errorContactNom}</Trans>
              </strong>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth >
            <TextField required
              label={
                <Trans>
                  {t("formulaireContact.lblChampPrenom")}
                </Trans>
              }
              name="prenom"
              autoComplete="given-name"
              value={contact.prenom}
              onChange={handleChange}
              variant="filled"    
              fullWidth
              aria-describedby="error-contact-prenom"
              style={{ backgroundColor: errorContactPrenom ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
            />
            {errorContactPrenom && (
              <strong id="error-contact-prenom" role="alert" className="error">
                <Trans>{errorContactPrenom}</Trans>
              </strong>
            )}
          </FormControl>
        </Grid>
      </Grid>
      
      <FormControl fullWidth >
        <TextField
          label={
            <Trans>
              {t("formulaireContact.lblChampTitre")}
            </Trans>
          }
          name="titre"
          autoComplete="honorific-suffix"
          value={contact.titre}
          onChange={handleChange}
          variant="filled"
          aria-describedby="error-contact-titre"
        />
        
      </FormControl>
      <Grid container>
        <Grid item xs={6}>
          <FormControl className="width-98" >
            <TextField required
              label={
                <Trans>
                  {t("formulaireContact.lblChampCourriel")}
                </Trans>
              }
              name="courriel"
              autoComplete="email"
              value={contact.courriel}
              onChange={handleChange}
              onBlur={() => onBlur("courriel")}
              variant="filled"
              fullWidth
              aria-describedby="error-contact-courriel"
              style={{ backgroundColor: errorContactCourriel ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
            />
            {errorContactCourriel && (
              <strong
                id="error-contact-courriel"
                role="alert"
                className="error"
              >
                <Trans>{errorContactCourriel}</Trans>
              </strong>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth >
            <TextField required
              label={
                <Trans>
                  {t("formulaireContact.lblChampTelephone")}
                </Trans>
              }
              name="telephone"
              autoComplete="tel"
              value={contact.telephone}
              onChange={handleChange}
              onBlur={() => onBlur("telephone")}
              variant="filled"
              fullWidth
              aria-describedby="error-contact-telephone"
              style={{ backgroundColor: errorContactTelephone ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
            />
            {errorContactTelephone && (
              <strong
                id="error-contact-telephone"
                role="alert"
                className="error"
              >
                <Trans>{errorContactTelephone}</Trans>
              </strong>
            )}
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
};

export default ContactForm;
